import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTopButton from "@/components/feature/ScrollToTopButton";
import TurismoHero from "./components/TurismoHero";
import TurismoNoticias from "./components/TurismoNoticias";
import { AdCintillo } from "@/components/feature/SponsorAds";
import NewsletterPopup from "@/components/feature/NewsletterPopup";
import SEO from "@/components/SEO";

export default function TurismoPage() {
  return (
    <main className="min-h-screen bg-white" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <SEO
        jsonLdSchemas={[
          {
            "@type": "WebPage",
            name: "Turismo Aéreo",
            description: "Conectividad turística, rutas charter, cruceros aéreos y viajes premium en República Dominicana y el Caribe.",
            url: 'https://aviacioninsightrd.com/turismo',
          },
        ]}
      />
      <Navbar />
      <TurismoHero />
      <AdCintillo placement="Turismo" />
      <TurismoNoticias />
      <NewsletterPopup />
      <Footer />
      <ScrollToTopButton />
    </main>
  );
}